import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowUp = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10.0013 18.9557C5.05964 18.9557 1.04297 14.9391 1.04297 9.9974C1.04297 5.05573 5.05964 1.03906 10.0013 1.03906C14.943 1.03906 18.9596 5.05573 18.9596 9.9974C18.9596 14.9391 14.943 18.9557 10.0013 18.9557ZM10.0013 2.28906C5.7513 2.28906 2.29297 5.7474 2.29297 9.9974C2.29297 14.2474 5.7513 17.7057 10.0013 17.7057C14.2513 17.7057 17.7096 14.2474 17.7096 9.9974C17.7096 5.7474 14.2513 2.28906 10.0013 2.28906Z",
			fill: "#7548F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 13.5391C9.65833 13.5391 9.375 13.2557 9.375 12.9141V7.91406C9.375 7.5724 9.65833 7.28906 10 7.28906C10.3417 7.28906 10.625 7.5724 10.625 7.91406V12.9141C10.625 13.2557 10.3417 13.5391 10 13.5391Z",
			fill: "#7548F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.5018 10.2089C12.3435 10.2089 12.1852 10.1505 12.0602 10.0255L10.0018 7.96719L7.94349 10.0255C7.70182 10.2672 7.30182 10.2672 7.06016 10.0255C6.81849 9.78385 6.81849 9.38385 7.06016 9.14219L9.56016 6.64219C9.80182 6.40052 10.2018 6.40052 10.4435 6.64219L12.9435 9.14219C13.1852 9.38385 13.1852 9.78385 12.9435 10.0255C12.8185 10.1505 12.6602 10.2089 12.5018 10.2089Z",
			fill: "#7548F0"
		})
	]
});
export default SvgArrowUp;
